import { Component, Input, OnChanges, OnInit, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { finalize, lastValueFrom } from 'rxjs';
import { DeclaracaoSaudeViewModel } from 'src/app/api/model/conta/proposta-externa/declaracao-saude/declaracaoSaudeVM';
import { ListaBeneficiariosViewModel } from 'src/app/api/model/conta/proposta-externa/declaracao-saude/listaBeneficiariosVM';
import { PropostaCotacaoService } from 'src/app/api/module/erp/services/area-logada/proposta-cotacao/proposta.cotacao.service';
import { PropostaExternaEnum } from 'src/app/api/module/erp/shared/enumerable/poposta-externa.enum';
import { TipoPropostaEnum } from 'src/app/api/module/erp/shared/enumerable/tipo-poposta.enum';
import { AtualizacaoForcadaService } from 'src/app/api/module/erp/shared/services/atualizacao-forcada-service.service';
import { CompartilharDadosEntreComponentsService } from 'src/app/api/module/erp/shared/services/compartilhar-dados-entre-components.service';
import { ErrorLoggingService } from 'src/app/api/module/erp/shared/services/error-logs/error-logging.service';
import { SpinnerService } from 'src/app/api/module/erp/shared/services/spinner-service.service';
import { TabNavigationService } from 'src/app/api/module/erp/shared/services/tab-navegation/tab-navegation.service';
import { BeneficiarioPropostaSerice } from 'src/app/api/module/externo/services/proposta/beneficiario.proposta.service';
import { DecalaracaoSaudePropostaService } from 'src/app/api/module/externo/services/proposta/declaracao-saude.proposta.service';
import { PerguntasDeclaracaoSaudeComponent } from './perguntas-declaracao-saude/perguntas-declaracao-saude.component';
import { PropostaDeclaracaoSaudeColaboradorComponent } from './proposta-declaracao-saude-colaborador/proposta-declaracao-saude-colaborador.component';

@Component({
  selector: 'app-proposta-associado-entidade-ds',
  templateUrl: './proposta-associado-entidade-ds.component.html',
  styleUrls: ['./proposta-associado-entidade-ds.component.scss'],
})
export class PropostaAssociadoEntidadeDsComponent implements OnInit, OnChanges {
  @ViewChild(PerguntasDeclaracaoSaudeComponent)
  _perguntasDeclaracaoSaudeComponent!: PerguntasDeclaracaoSaudeComponent;
  heMedSenior: any;
  @ViewChild('stepper') set matStepper(stepper: MatStepper) {
    this.stepper = stepper;
    this.atualizarStepper(); // Atualiza o step quando o stepper estiver pronto
  }
  @ViewChild(PropostaDeclaracaoSaudeColaboradorComponent)
  _propostaDeclaracaoSaudeColaboradorComponent!: PropostaDeclaracaoSaudeColaboradorComponent;
  @ViewChild('templateModal') templateModal!: TemplateRef<any>;
  @ViewChild('modalCancelamentoPlanoAnterior')
  modalCancelamentoPlanoAnterior: any;
  @Input() abaAtiva: boolean = false;
  @Input() somenteLeituraStep: boolean = false;

  stepper!: MatStepper;
  stepAtual: PropostaExternaEnum = PropostaExternaEnum.CARTA_ORIENTACAO;
  declaracaoSaudeVM = new DeclaracaoSaudeViewModel();
  propostaEnum = PropostaExternaEnum;
  listaDeBeneficiario = new Array<any>();
  formDeclaracaoSaude!: FormGroup;
  isLinear: boolean = false;
  errorMessage: boolean = false;
  isFormSubmited: boolean = false;
  formTouched: boolean = false;
  nome!: string;
  ehMasculino!: boolean;
  idade!: number;
  limitePerguntas!: number;
  idBeneficiarioAtual!: string;
  proposalId!: string;
  id!: string;
  respostasOrganizadaPorBeneficiario: any = { titular: [], dependente: {} };
  ultimaPerguntaRespondida: any;
  ultimaPerguntaRespondidaCodigo: any;
  totalPerguntas!: number;
  ehDependente: boolean = false;
  mostrarModalRetornoDS: boolean = true;
  sizeModal: string = '';
  titleModal: string = '';
  idModal: string = '';
  hideCloseButton: boolean = false;
  modalRef!: BsModalRef;
  concluirRetornoDS: boolean = false;
  finalizarPerguntasRetornoDs: boolean = false;
  modalCancelamentoRef?: BsModalRef;
  private modalAberto: boolean = false;
  checkboxSumula: any;
  cpf: any;
  tipoProposta: any;
  nomeModalCancelamento: any;
  idUrl: any;
  dependentInclusion: boolean = false;
  dadosRecebidosVM: any;
  perguntaRetornada: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private _activeRoute: ActivatedRoute,
    private _decalaracaoSaudePropostaService: DecalaracaoSaudePropostaService,
    private _propostaCotacaoService: PropostaCotacaoService,
    private _atualizacaoForcadaService: AtualizacaoForcadaService,
    private _router: Router,
    private tabService: TabNavigationService,
    private bsModalService: BsModalService,
    private _compartilharDadosEntreComponentsService: CompartilharDadosEntreComponentsService,
    private _spinnerService: SpinnerService,
    private _beneficiarioPropostaService: BeneficiarioPropostaSerice,
    private _errorLoggingService: ErrorLoggingService,
  ) {}

  get heColaborador(): boolean {
    return this._router.url.includes('colaborador');
  }

  ngOnInit() {
    this._perguntasDeclaracaoSaudeComponent;
    this._propostaDeclaracaoSaudeColaboradorComponent;
    this.criarFormulario();
    this.obterIDdaUrl();
    this.receberDadosCompartilhados();
    this.tabService.declaracaoSaudeAtivada$.subscribe(() => {
      if (!this.heColaborador && !this.modalAberto && this.stepAtual == PropostaExternaEnum.CARTA_ORIENTACAO) {
        this.exibirModalParaBeneficiariosSumula();
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.heColaborador) {
      if (this.somenteLeituraStep) {
        this.formDeclaracaoSaude && this.formDeclaracaoSaude.disable();
      } else {
        this.formDeclaracaoSaude && this.formDeclaracaoSaude?.enable({emitEvent: true});
      }
    }
  }

  iniciarSpinner() {
    this._spinnerService.show();
  }

  pararSpinner(ms?: number) {
    return new Promise(resolve => {
      setTimeout(() => {
        this._spinnerService.hide();
        resolve(true);
      }, ms);
    });
  }

  obterIDdaUrl() {
    this._activeRoute.paramMap.subscribe(params => {
      this.idUrl = params.get('idProposta');
      if (!this.heColaborador) {
        this.buscarBeneficiario(this.idUrl);
      }
    });
  }

  criarFormulario() {
    this.formDeclaracaoSaude = this.formBuilder.group({
      optionForPreExistingIllnesses: new FormControl(3, Validators.required),
    });
  }

  ocultarBtn(): boolean {
    return this.ehDependente && this._perguntasDeclaracaoSaudeComponent?.currentQuestionIndex === 0;
  }

  getTotalPerguntas(): number {
    const TOTAL_PERGUNTAS = {
      masculinoAdulto: 26,
      femininoAdulto: 27,
    };

    if (this.ehMasculino) {
      this.limitePerguntas = TOTAL_PERGUNTAS.masculinoAdulto;
      return TOTAL_PERGUNTAS.masculinoAdulto;
    } else {
      this.limitePerguntas = TOTAL_PERGUNTAS.femininoAdulto;
      return TOTAL_PERGUNTAS.femininoAdulto;
    }
  }

  onFieldChange() {
    if (this.formTouched) {
      this.errorMessage = !this.isFormValid();
    }
  }

  isFormValid() {
    this.isFormSubmited = true;
    return this.formDeclaracaoSaude.valid;
  }

  concordarCartaOrientacao() {
    if (this.somenteLeituraStep) {
      this.stepAtual = PropostaExternaEnum.CARTA_ORIENTACAO;
      this.redirecionamentoDeStep(false);
    } else {
      this._decalaracaoSaudePropostaService.aceitarCartarDeOrientacao(this.proposalId).subscribe(data => {
        this.toastr.success('Carta de Orientação ao beneficiário aceita com sucesso!');
        this.id = data && data.id;
        let termoRespondido;
        const respostasTitular = this.respostasOrganizadaPorBeneficiario?.titular || [];
        if (Array.isArray(respostasTitular)) {
          respostasTitular
            .filter((item: any) => item.codeQuestion === 99)
            .forEach((itemFiltradoTitular: any) => {
              if (itemFiltradoTitular.optionForPreExistingIllnesses) {
                termoRespondido = true;
              }
            });
        }
        if (termoRespondido || this.dependentInclusion) {
          this.stepAtual = PropostaExternaEnum.TERMO;
          this.stepper.selectedIndex = this.getStepIndexFromEnum(this.stepAtual);
          this.redirecionamentoDeStep(false);
          this._beneficiarioPropostaService
            .atualizarStep(this.proposalId, PropostaExternaEnum.QUESTIONARIO)
            .subscribe();
        } else {
          this.stepAtual = PropostaExternaEnum.CARTA_ORIENTACAO;
          this.redirecionamentoDeStep(false);
        }
      });
      setTimeout(() => {
        this.toastr.toastrConfig.preventDuplicates = true;
        this.pararSpinner();
      }, 1000);
    }
  }

  calcularIdade(dataNascimento: string): number {
    const hoje = new Date();
    const nascimento = new Date(dataNascimento);
    let idade = hoje.getFullYear() - nascimento.getFullYear();
    const mes = hoje.getMonth() - nascimento.getMonth();
    if (mes < 0 || (mes === 0 && hoje.getDate() < nascimento.getDate())) {
      idade--;
    }
    return idade;
  }

  organizarRespostasDosBeneficiarios(dados: any) {
    const dadosRecebidos = Array.isArray(dados) ? dados : [];
    const respostasOrganizadas: any = {titular: [], dependente: {}};

    dadosRecebidos.forEach((item: any) => {
      if (item.holderProposalId) respostasOrganizadas.titular.push(item);
      if (item.dependentProposalId) {
        if (!respostasOrganizadas.dependente[item.dependentProposalId]) {
          respostasOrganizadas.dependente[item.dependentProposalId] = [];
        }
        respostasOrganizadas.dependente[item.dependentProposalId].push(item);
      }
    });

    if (Array.isArray(respostasOrganizadas.titular)) {
      respostasOrganizadas.titular.sort((a: any, b: any) => (a.codeQuestion || 0) - (b.codeQuestion || 0));
    }
    Object.keys(respostasOrganizadas.dependente || {}).forEach(key => {
      if (Array.isArray(respostasOrganizadas.dependente[key])) {
        respostasOrganizadas.dependente[key].sort((a: any, b: any) => (a.codeQuestion || 0) - (b.codeQuestion || 0));
      }
    });

    this.respostasOrganizadaPorBeneficiario = respostasOrganizadas;
  }

  termoDoQuestionarioRespondido() {
    let possuiResposta = false;
    //titular
    const respostasTitular = this.respostasOrganizadaPorBeneficiario?.titular || [];
    if (Array.isArray(respostasTitular)) {
      respostasTitular
        .filter((item: any) => item.codeQuestion === 99)
        .forEach((itemFiltradoTitular: any) => {
          if (itemFiltradoTitular.optionForPreExistingIllnesses) {
            this.formDeclaracaoSaude.patchValue({
              optionForPreExistingIllnesses: itemFiltradoTitular.optionForPreExistingIllnesses,
            });
            possuiResposta = true;
          }

          this.listaDeBeneficiario = this.listaDeBeneficiario.map((beneficiario: any) =>
            beneficiario.id === this.idBeneficiarioAtual ? {...beneficiario, preenchido: true} : beneficiario,
          );
        });
    }

    //dependente
    const dependenteObj = this.respostasOrganizadaPorBeneficiario?.dependente || {};
    Object.values(dependenteObj).forEach((dependenteRespostas: any) => {
      if (Array.isArray(dependenteRespostas)) {
        dependenteRespostas
          .filter((item: any) => item.codeQuestion === 99 && item.optionForPreExistingIllnesses)
          .forEach((itemFiltradoDependente: any) => {
            this.listaDeBeneficiario = this.listaDeBeneficiario.map((beneficiario: any) =>
              beneficiario.id === itemFiltradoDependente.dependentProposalId
                ? {...beneficiario, preenchido: true}
                : beneficiario,
            );

            if (itemFiltradoDependente.dependentProposalId === this.idBeneficiarioAtual) {
              this.formDeclaracaoSaude.patchValue({
                optionForPreExistingIllnesses: itemFiltradoDependente.optionForPreExistingIllnesses,
              });
              possuiResposta = true;
            }
          });
      }
    });

    // Se não possui resposta, define o valor padrão 3
    if (!possuiResposta) {
      this.formDeclaracaoSaude.patchValue({
        optionForPreExistingIllnesses: 3,
      });
    }
  }

  termoQuestionarioPreenchido() {
    this.iniciarSpinner();
    try {
      this.declaracaoSaudeVM = new DeclaracaoSaudeViewModel();
      this.declaracaoSaudeVM.proposalId = this.proposalId;
      this.declaracaoSaudeVM.codeQuestion = 99;
      this.declaracaoSaudeVM.optionForPreExistingIllnesses =
        this.formDeclaracaoSaude.controls['optionForPreExistingIllnesses'].value;

      const beneficiarioAtual = this.listaDeBeneficiario.find((item: any) => item.id === this.idBeneficiarioAtual);

      if (beneficiarioAtual) {
        if (!beneficiarioAtual.isDependent) {
          this.declaracaoSaudeVM.holderProposalId = beneficiarioAtual.id;

          const respostasTitular = this.respostasOrganizadaPorBeneficiario?.titular || [];
          const respostaTitular = Array.isArray(respostasTitular)
            ? respostasTitular.find(
                (resposta: any) =>
                  resposta.holderProposalId === this.declaracaoSaudeVM.holderProposalId && resposta.codeQuestion === 99,
              )
            : null;
          this.declaracaoSaudeVM.id = respostaTitular ? respostaTitular.id : null;
        } else {
          this.declaracaoSaudeVM.dependentProposalId = beneficiarioAtual.id;
          const respostasDependente = this.respostasOrganizadaPorBeneficiario?.dependente?.[beneficiarioAtual.id];

          if (Array.isArray(respostasDependente)) {
            const respostaDependente = respostasDependente.find((resposta: any) => resposta.codeQuestion === 99);
            this.declaracaoSaudeVM.id = respostaDependente ? respostaDependente.id : null;
          }
        }
      }

      if (this.somenteLeituraStep) {
        this.redirecionamentoDeStep(false);
        this.atualizarStepper();
        this.pararSpinner();
      } else {
        this._decalaracaoSaudePropostaService
          .responderPerguntas(this.proposalId, this.declaracaoSaudeVM)
          .pipe(finalize(() => this.pararSpinner()))
          .subscribe({
            next: (data: any) => {
              this.listaDeBeneficiario.forEach((item: any) => {
                if (item.id === this.idBeneficiarioAtual) item.preenchido = true;
              });
              this.toastr.success('Declaração de saúde respondida com sucesso:');
              this.redirecionamentoDeStep(false);
              this.atualizarStepper();
            },
            error: (error: any) => {
              this.toastr.warning('Por favor, responda à pergunta antes de avançar.');
            },
          });
      }
    } catch (error) {
      this.pararSpinner();
      this._errorLoggingService.logError('Erro ao avançar termo do questionário', error, {
        proposalId: this.proposalId,
        idBeneficiarioAtual: this.idBeneficiarioAtual,
      });
      this.toastr.error('Erro ao processar termo do questionário.');
    }
  }

  finalizarPerguntas(totalPerguntas: any): void {
    if (totalPerguntas(this._perguntasDeclaracaoSaudeComponent.currentQuestionIndex + 1)) {
      this.VerificarPerguntasRespondidas(this.proposalId);
    }
  }

  validarResposta() {
    this.iniciarSpinner();
    const atingiuLimitePerguntas = (indiceAtual: number) => indiceAtual === this.getTotalPerguntas();
    switch (this.stepAtual) {
      case PropostaExternaEnum.PERGUNTAS:
        if (
          this._perguntasDeclaracaoSaudeComponent &&
          this._perguntasDeclaracaoSaudeComponent.perguntasDeclaracaoSaude
        ) {
          const totalPerguntas = this._perguntasDeclaracaoSaudeComponent.perguntasDeclaracaoSaude.length;
          if (this.somenteLeituraStep) {
            if (this._perguntasDeclaracaoSaudeComponent.currentQuestionIndex < totalPerguntas - 1) {
              this._perguntasDeclaracaoSaudeComponent.onAvancar(this.idBeneficiarioAtual);
            } else {
              this.termoDoQuestionarioRespondido();
              this.redirecionamentoDeStep(false);
              this.atualizarStepper();
            }
          } else {
            if (this._perguntasDeclaracaoSaudeComponent.currentQuestionIndex <= totalPerguntas - 1) {
              const respostaAtualCampoRadio =
                this._perguntasDeclaracaoSaudeComponent.formPerguntas.get('response')?.value;
              const respostaAtualCampoIMC =
                this._perguntasDeclaracaoSaudeComponent.formPerguntas.get('height')?.value ||
                this._perguntasDeclaracaoSaudeComponent.formPerguntas.get('weight')?.value;

              if (respostaAtualCampoRadio !== null || respostaAtualCampoIMC) {
                this._perguntasDeclaracaoSaudeComponent.onAvancar(this.idBeneficiarioAtual);
                const perguntaPesoComValor = this._perguntasDeclaracaoSaudeComponent.peso ?? 0;
                if (
                  this._perguntasDeclaracaoSaudeComponent.currentQuestionIndex >= totalPerguntas - 1 &&
                  !perguntaPesoComValor
                ) {
                  this.pararSpinner();
                  this.toastr.warning('Responda a pergunta antes de avançar');
                  return;
                }

                this.finalizarPerguntas(atingiuLimitePerguntas);
                //encerra perguntas e vai para o próximo step
                if (this._perguntasDeclaracaoSaudeComponent.currentQuestionIndex >= totalPerguntas - 1) {
                  this.redirecionamentoDeStep(false);
                  this.atualizarStepper();
                  this._perguntasDeclaracaoSaudeComponent.peso = 0;
                }
              } else {
                this.toastr.warning('Por favor, responda à pergunta antes de avançar.');
              }
            }
          }
        } else {
          this.toastr.error('Ocorreu um erro. Tente novamente mais tarde.');
        }
        this.pararSpinner(1000);

        break;
      default:
        break;
    }
  }

  async voltarPerguntasOuStep(step?: PropostaExternaEnum, item?: any) {
    try {
      if (item) {
        await this.VerificarPerguntasRespondidas(this.proposalId, true);
        this.stepAtual = step as PropostaExternaEnum;
        this.redirecionamentoDeStep(true);
        this._perguntasDeclaracaoSaudeComponent && this._perguntasDeclaracaoSaudeComponent.formPerguntas.reset();
        this._perguntasDeclaracaoSaudeComponent &&
          (this._perguntasDeclaracaoSaudeComponent.perguntasDeclaracaoSaude = []);
        this._perguntasDeclaracaoSaudeComponent && this._perguntasDeclaracaoSaudeComponent.buscarPerguntas();
        this._perguntasDeclaracaoSaudeComponent && (this._perguntasDeclaracaoSaudeComponent.currentQuestionIndex = 0);
        this._perguntasDeclaracaoSaudeComponent && (this._perguntasDeclaracaoSaudeComponent.imc = null);
        this._perguntasDeclaracaoSaudeComponent && (this._perguntasDeclaracaoSaudeComponent.ehIMC = false);
        this.inicializarFormularioParaBeneficiario();
        this.idBeneficiarioAtual = item.id;
        this._perguntasDeclaracaoSaudeComponent && (this._perguntasDeclaracaoSaudeComponent.nome = item.name);
        this._perguntasDeclaracaoSaudeComponent &&
          (this._perguntasDeclaracaoSaudeComponent.idade = this.calcularIdade(item.birthDate));
        this.idade = this.calcularIdade(item.birthDate);
        this.nome = item.name;
        this._perguntasDeclaracaoSaudeComponent &&
          (this._perguntasDeclaracaoSaudeComponent.ehMasculino = item.sex == 1);
        this.ehDependente = item.isDependent;
        this.totalPerguntas = this.getTotalPerguntas();
        this._perguntasDeclaracaoSaudeComponent &&
          this._perguntasDeclaracaoSaudeComponent.filtrarPerguntasPorGeneroEIdade(this.idBeneficiarioAtual);
        let respostasBeneficiarioAtual = this.ehDependente
          ? this.respostasOrganizadaPorBeneficiario?.dependente?.[this.idBeneficiarioAtual] || []
          : this.respostasOrganizadaPorBeneficiario?.titular || [];

        if (Array.isArray(respostasBeneficiarioAtual) && respostasBeneficiarioAtual.some((resposta: any) => resposta.codeQuestion >= 99)) {
          this.stepAtual = PropostaExternaEnum.PERGUNTAS;
          this.redirecionamentoDeStep(true);
          this._perguntasDeclaracaoSaudeComponent &&
            this._perguntasDeclaracaoSaudeComponent.verificarPreencherFormulario(this.idBeneficiarioAtual);
          this.pararSpinner();
          return;
        } else if (
          respostasBeneficiarioAtual.length >= this._perguntasDeclaracaoSaudeComponent &&
          this._perguntasDeclaracaoSaudeComponent.qtdPerguntasFormAtual
        ) {
          this.stepAtual = PropostaExternaEnum.TERMO;
          this.redirecionamentoDeStep(true);
          this.pararSpinner();
          return;
        }

        if (
          this._perguntasDeclaracaoSaudeComponent &&
          this._perguntasDeclaracaoSaudeComponent.currentQuestionIndex === 0 &&
          respostasBeneficiarioAtual.length
        ) {
          this._perguntasDeclaracaoSaudeComponent &&
            (this._perguntasDeclaracaoSaudeComponent.currentQuestionIndex = respostasBeneficiarioAtual.length);
          this._perguntasDeclaracaoSaudeComponent && this._perguntasDeclaracaoSaudeComponent.atualizarPergunta();
        }
        this.stepAtual = PropostaExternaEnum.PERGUNTAS;
        this.redirecionamentoDeStep(true);
        this._perguntasDeclaracaoSaudeComponent &&
          this._perguntasDeclaracaoSaudeComponent.verificarPreencherFormulario(this.idBeneficiarioAtual);
        return;
      }

      await this.VerificarPerguntasRespondidas(this.proposalId, true, this.idBeneficiarioAtual);

      switch (this.stepAtual) {
        case PropostaExternaEnum.PERGUNTAS:
          //volta para pergunta anterior
          if (
            this._perguntasDeclaracaoSaudeComponent &&
            this._perguntasDeclaracaoSaudeComponent.currentQuestionIndex > 0
          ) {
            this._perguntasDeclaracaoSaudeComponent.voltarPerguntas = true;
            this._perguntasDeclaracaoSaudeComponent.onVoltar(this.idBeneficiarioAtual);
          } else {
            this.stepAtual = PropostaExternaEnum.PERGUNTAS;
            this.redirecionamentoDeStep(false, true);
            this.atualizarStepper();
          }
          break;
        case PropostaExternaEnum.TERMO:
          //volta step de perguntas
          this.stepAtual = PropostaExternaEnum.PERGUNTAS;
          this.getStepIndexFromEnum(PropostaExternaEnum.PERGUNTAS);

          this._perguntasDeclaracaoSaudeComponent && this._perguntasDeclaracaoSaudeComponent.formPerguntas.reset();
          this._perguntasDeclaracaoSaudeComponent &&
            (this._perguntasDeclaracaoSaudeComponent.perguntasDeclaracaoSaude = []);
          this._perguntasDeclaracaoSaudeComponent && this._perguntasDeclaracaoSaudeComponent.buscarPerguntas();
          this._perguntasDeclaracaoSaudeComponent && (this._perguntasDeclaracaoSaudeComponent.currentQuestionIndex = 0);
          this._perguntasDeclaracaoSaudeComponent && (this._perguntasDeclaracaoSaudeComponent.imc = null);
          this._perguntasDeclaracaoSaudeComponent && (this._perguntasDeclaracaoSaudeComponent.ehIMC = false);
          this.formDeclaracaoSaude.reset();
          this._perguntasDeclaracaoSaudeComponent &&
            this._perguntasDeclaracaoSaudeComponent.filtrarPerguntasPorGeneroEIdade(this.idBeneficiarioAtual);
          this._perguntasDeclaracaoSaudeComponent &&
            this._perguntasDeclaracaoSaudeComponent.verificarPreencherFormulario(this.idBeneficiarioAtual);
          this.pararSpinner();
          break;
        default:
          break;
      }
    } catch (error) {
      this.toastr.error('Erro ao processar a verificação do formulário.');
    }
  }

  separarBeneficiarios(dados: any) {
    const beneficiario = dados && dados.holderProposal;
    if (beneficiario) {
      const dadosTitular = {...beneficiario};
      delete dadosTitular.dependentsProposal;
      this.idBeneficiarioAtual = dadosTitular.id;
      this.nome = dadosTitular.name;
      this.cpf = dadosTitular.cpf;
      this.idade = this.calcularIdade(dadosTitular.birthDate);
      this.ehMasculino = dadosTitular.sex === 1;
      this.proposalId = dadosTitular.proposalId;
      this._perguntasDeclaracaoSaudeComponent.proposalId = this.proposalId;

      this.listaDeBeneficiario.push({
        ...dadosTitular,
        isDependent: false,
        preenchido: this.dependentInclusion,
        idadeCalculada: this.idade,
        proposalType: dados.proposalType,
      });

      if (beneficiario.dependentsProposal && Array.isArray(beneficiario.dependentsProposal)) {
        beneficiario.dependentsProposal.forEach((dependente: any) => {
          const idadeDependente = this.calcularIdade(dependente.birthDate);

          const itemDependente = {
            ...dependente,
            isDependent: true,
            preenchido: false, //controla o status da pergunta  - pinta verde
            idadeCalculada: idadeDependente,
          };
          this.listaDeBeneficiario.push(itemDependente);
        });
      }
    }
  }

  redirecionamentoDeStep(iniciandoComponente?: boolean, voltarStepAnterior?: boolean) {
    if (!this.stepper) return;
    const currentStepEnum = this.getIndexEnumDoStep(this.stepper.selectedIndex);
    switch (currentStepEnum) {
      case PropostaExternaEnum.CARTA_ORIENTACAO:
        this.stepAtual = PropostaExternaEnum.PERGUNTAS;
        break;

      case PropostaExternaEnum.PERGUNTAS:
        if (voltarStepAnterior) {
          this.stepAtual = PropostaExternaEnum.CARTA_ORIENTACAO;
          return;
        }
        this.stepAtual = PropostaExternaEnum.TERMO;
        break;

      case PropostaExternaEnum.TERMO:
        if (voltarStepAnterior) {
          this.stepAtual = PropostaExternaEnum.PERGUNTAS;
          return;
        }
        this.stepAtual = PropostaExternaEnum.QUESTIONARIO;
        break;

      case PropostaExternaEnum.QUESTIONARIO:
        if (voltarStepAnterior) {
          this.stepAtual = PropostaExternaEnum.TERMO;
          return;
        }
        this.stepAtual = PropostaExternaEnum.RETORNO_DS;
        break;

      case PropostaExternaEnum.RETORNO_DS:
        if (voltarStepAnterior) {
          this.stepAtual = PropostaExternaEnum.QUESTIONARIO;
          return;
        }
        break;
    }

    this.stepper.selectedIndex = this.getStepIndexFromEnum(this.stepAtual);
  }

  atualizarStepper() {
    setTimeout(() => {
      if (this.stepper) {
        this.stepper.selectedIndex = this.getStepIndexFromEnum(this.stepAtual);
      }
    });
  }

  getStepIndexFromEnum(enumValue: number): number {
    const stepsOrder = [
      PropostaExternaEnum.CARTA_ORIENTACAO,
      PropostaExternaEnum.PERGUNTAS,
      PropostaExternaEnum.TERMO,
      PropostaExternaEnum.QUESTIONARIO,
      PropostaExternaEnum.RETORNO_DS,
    ];
    return stepsOrder.indexOf(enumValue);
  }

  getIndexEnumDoStep(stepIndex: number): PropostaExternaEnum {
    const stepsOrder = [
      PropostaExternaEnum.CARTA_ORIENTACAO,
      PropostaExternaEnum.PERGUNTAS,
      PropostaExternaEnum.TERMO,
      PropostaExternaEnum.QUESTIONARIO,
      PropostaExternaEnum.RETORNO_DS,
    ];
    return stepsOrder[stepIndex];
  }

  async buscarBeneficiario(id: string): Promise<void> {
    this.iniciarSpinner();
    this.listaDeBeneficiario = [];
    try {
      const data = await lastValueFrom(this._propostaCotacaoService.buscarDadosPropostaPorId(id)).finally(() => {
        this.pararSpinner();
      });

      if (!data) return;
      this.dependentInclusion = data?.dependentInclusion;

      const dadosCompletos = data && data;
      this.separarBeneficiarios(dadosCompletos);
      this.tipoProposta = data.proposalType;
      this.totalPerguntas = this.getTotalPerguntas();

      if (data.step) {
        this.stepAtual = data.step as PropostaExternaEnum;
        if (this.stepAtual == PropostaExternaEnum.RETORNO_DS) {
          this.tabService.definirAbaAtivaPorNumero(PropostaExternaEnum.CARTA_ORIENTACAO);

          this.stepAtual = data.step as PropostaExternaEnum;
          this.getStepIndexFromEnum(this.stepAtual);
          await this.buscarPerguntasDoRetornoDS();
          // setTimeout(() => {
          //   if (this.perguntaRetornada) this.abrirModal();
          // }, 0);

          return;
        }
        //RN - a carta de orientacao deve ser exibida somente par ao tiular.
        else if (
          this.stepAtual >= PropostaExternaEnum.CARTA_ORIENTACAO &&
          this.stepAtual <= PropostaExternaEnum.QUESTIONARIO
        ) {
          this.tabService.definirAbaAtivaPorNumero(PropostaExternaEnum.CARTA_ORIENTACAO);
          this.stepAtual = data.step as PropostaExternaEnum;
          this.getStepIndexFromEnum(this.stepAtual);

          if (!this.heColaborador && data.step == PropostaExternaEnum.CARTA_ORIENTACAO) {
            this.exibirModalParaBeneficiariosSumula();
          }
        } else if (this.stepAtual < PropostaExternaEnum.CARTA_ORIENTACAO) {
          this.tabService.definirAbaAtivaPorNumero(PropostaExternaEnum.CARTA_ORIENTACAO);
          this.stepAtual = PropostaExternaEnum.CARTA_ORIENTACAO as PropostaExternaEnum;
          this.getStepIndexFromEnum(this.stepAtual);
        } else {
          this.stepAtual = PropostaExternaEnum.QUESTIONARIO;
          this.getStepIndexFromEnum(PropostaExternaEnum.QUESTIONARIO);
        }
      }
      if (!this.dependentInclusion) {
        await this.VerificarPerguntasRespondidas(this.proposalId, false, this.idBeneficiarioAtual);
        this._perguntasDeclaracaoSaudeComponent &&
          this._perguntasDeclaracaoSaudeComponent.filtrarPerguntasPorGeneroEIdade(this.idBeneficiarioAtual);
      } else {
        if (this.stepAtual === PropostaExternaEnum.PERGUNTAS) {
          this.stepAtual = PropostaExternaEnum.QUESTIONARIO;
          this.getStepIndexFromEnum(this.stepAtual);
        }
      }

      this.pararSpinner();
    } catch (error) {
      this._errorLoggingService.logError('Erro ao buscar dados da proposta na DS', error, {});
    }
  }

  async VerificarPerguntasRespondidas(
    proposalId: string,
    voltarCampos?: boolean,
    idBeneficiarioAtual?: string,
  ): Promise<void> {
    return new Promise((resolve, reject) => {
      this._decalaracaoSaudePropostaService
        .buscarPerguntasRespondidas(proposalId)
        .pipe(finalize(() => this.pararSpinner()))
        .subscribe({
          next: data => {
            this.organizarRespostasDosBeneficiarios(data);
            if (data && data.length > 0) {
              //mostra a proxima pergunta quando esta preenchendo o formulario  do titular
              if (idBeneficiarioAtual && !voltarCampos) {
                let ultimaPerguntaRespondida: any = null;
                const respostasTitular = this.respostasOrganizadaPorBeneficiario?.titular || [];
                const dependentesObj = this.respostasOrganizadaPorBeneficiario?.dependente || {};

                // Verificar se o beneficiário atual é titular
                if (
                  Array.isArray(respostasTitular) &&
                  respostasTitular.some(
                    (item: any) => item.holderProposalId === idBeneficiarioAtual,
                  )
                ) {
                  // Encontrar o maior codeQuestion do titular
                  ultimaPerguntaRespondida = respostasTitular.reduce(
                    (prev: any, current: any) => {
                      return (prev.codeQuestion || 0) > (current.codeQuestion || 0) ? prev : current;
                    },
                  );
                }
                // Verificar se o beneficiário atual é dependente
                else if (
                  Array.isArray(dependentesObj[idBeneficiarioAtual]) &&
                  dependentesObj[idBeneficiarioAtual].length > 0
                ) {
                  // Encontrar o maior codeQuestion do dependente
                  ultimaPerguntaRespondida = dependentesObj[idBeneficiarioAtual].reduce(
                    (prev: any, current: any) => {
                      return (prev.codeQuestion || 0) > (current.codeQuestion || 0) ? prev : current;
                    },
                  );
                }
                // Ajustar o índice da pergunta com base no maior codeQuestion
                if (ultimaPerguntaRespondida) {
                  this._perguntasDeclaracaoSaudeComponent.currentQuestionIndex = ultimaPerguntaRespondida.codeQuestion;
                }
              }

              this.termoDoQuestionarioRespondido();

              if (this._perguntasDeclaracaoSaudeComponent) {
                this._perguntasDeclaracaoSaudeComponent.listaDeRespostasBeneficiarios =
                  new ListaBeneficiariosViewModel();
                this._perguntasDeclaracaoSaudeComponent.listaDeRespostasBeneficiarios =
                  this.respostasOrganizadaPorBeneficiario;
              }
              resolve();
            } else {
              this._perguntasDeclaracaoSaudeComponent.listaDeRespostasBeneficiarios =
                this.respostasOrganizadaPorBeneficiario;
              resolve();
            }
          },
          error: error => {
            reject(error);
          },
        });
    });
  }

  abrirModal() {
    this.titleModal = 'Atualização da Declaração de Saúde';
    this.sizeModal = 'modal-dialog modal-lg';
    this.idModal = 'retornoDS';
    this.modalRef = this.bsModalService.show(this.templateModal, {
      class: 'modal-lg',
    });
  }

  fecharModal() {
    this._atualizacaoForcadaService.fecharModal();
  }

  onFinalizarDeclaracaoSaude() {
    if (this.somenteLeituraStep) {
      this.tabService.avancarParaProximaAba('documentos');
    } else {
      const todosPreenchidos =
        this.listaDeBeneficiario && this.listaDeBeneficiario.every(beneficiario => beneficiario.preenchido === true);

      if (todosPreenchidos) {
        this._beneficiarioPropostaService
          .atualizarStep(this.proposalId, PropostaExternaEnum.DOCUMENTO)
          .subscribe(data => {
            this.dadosRecebidosVM[0].dadosBeneficiario.step = PropostaExternaEnum.DOCUMENTO;
            this.toastr.success('Questionário(s) respondido(s) com sucesso.');
            this.toastr.toastrConfig.preventDuplicates = true;
            this.tabService.avancarParaProximaAba('documentos');
            this.enviarDados(this.dadosRecebidosVM);
          });
      } else {
        this.toastr.warning('Todos os beneficiários precisam responder o questionário para avançar.');
        this.toastr.toastrConfig.preventDuplicates = true;
      }
    }
  }

  async buscarPerguntasDoRetornoDS() {
    this._decalaracaoSaudePropostaService.buscarPerguntasRetornada(this.proposalId).subscribe(data => {
      let dadosRecebidos = data && data;
      this.perguntaRetornada = Array.isArray(dadosRecebidos) && dadosRecebidos.length > 0;
      if (this.perguntaRetornada) {
        this.enviarDados(dadosRecebidos);
        this._atualizacaoForcadaService.emitirAtualizacaoForcadaRetornoDS();
        this.abrirModal();
      } else {
        this.toastr.warning('Nenhuma pergunta alterada na videoconferência.');
        this.toastr.toastrConfig.preventDuplicates = true;
      }
    });
  }

  ocultarBtnVoltarRetornoDS(): boolean {
    return this._perguntasDeclaracaoSaudeComponent?.currentQuestionIndex === 0;
  }

  voltarPerguntaRetornoDS() {
    this._atualizacaoForcadaService.emitirAtualizacaoForcadaRetornoDSVoltarPergunta();
    this.concluirRetornoDS = false;
    this.finalizarPerguntasRetornoDs = false;
  }

  avancarPerguntaRetornoDS() {
    if (this.finalizarPerguntasRetornoDs) {
      this.iniciarSpinner();
      this._decalaracaoSaudePropostaService.aceiteBeneficiarioPerguntasRetornadas(this.proposalId).subscribe(data => {
        this.pararSpinner();
        this.toastr.success('Revisão das perguntas da Declaração de Saúde concluida com sucesso!');
        this.toastr.toastrConfig.preventDuplicates = true;
        this.recarregarRota();
      });
    } else {
      this._atualizacaoForcadaService.emitirAtualizacaoForcadaRetornoDSProximaPergunta();
    }
  }

  finalizarRetornoDS(evento: any) {
    this.finalizarPerguntasRetornoDs = evento;
    this.concluirRetornoDS = true;
  }

  enviarDados(data: any) {
    this._compartilharDadosEntreComponentsService.enviarDadosParaOutroComponent(data);
  }

  async exibirModalParaBeneficiariosSumula() {
    const beneficiariosSumula = this.listaDeBeneficiario.filter(item => item.proposalType === TipoPropostaEnum.SUMULA);

    for (const beneficiario of beneficiariosSumula) {
      if (this.modalAberto) {
        return;
      }
      await this.abrirModalCancelamentoAsync(beneficiario);
    }
  }

  abrirModalCancelamentoAsync(beneficiario: any): Promise<void> {
    return new Promise(resolve => {
      this.nomeModalCancelamento = beneficiario.name;
      this.cpf = beneficiario.cpf;
      this.checkboxSumula = false;
      this.modalAberto = true;

      this.modalCancelamentoRef = this.bsModalService.show(this.modalCancelamentoPlanoAnterior, {
        backdrop: 'static',
        class: 'modal-lg',
        id: 'sumula',
      });

      const subscription = this.bsModalService.onHidden.subscribe(() => {
        this.modalAberto = false;
        subscription.unsubscribe();
        resolve();
      });
    });
  }

  fecharModalCancelamento() {
    if (this.modalCancelamentoRef) {
      this.modalCancelamentoRef.hide();
      this.modalAberto = false;
    }
  }

  inicializarFormularioParaBeneficiario() {
    this.formDeclaracaoSaude.reset();

    this.formDeclaracaoSaude.patchValue({
      optionForPreExistingIllnesses: 3,
    });
  }

  recarregarRota() {
    const currentUrl = this._router.url;
    this._router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
      this._router.navigate([currentUrl]);
    });
  }

  receberDadosCompartilhados(): Promise<any> {
    return new Promise(reject => {
      this._compartilharDadosEntreComponentsService.obterDadosCompartilhados().subscribe(
        data => {
          this.dadosRecebidosVM = data && data;
          this.heMedSenior = this.dadosRecebidosVM[0].dadosBeneficiario.operatorName.toLowerCase() === 'medsenior';
        },
        error => {
          reject(error);
        },
      );
    });
  }

  onRespostaEnvioImagem(resposta: {step: string; mensagem?: string; pessoaId?: string}) {
    if (resposta.step === 'erro') {
      this.toastr.error('Erro ao enviar imagem:', resposta.mensagem);
      // Tratar erro - pode mostrar modal, mudar step, etc.
    } else if (resposta.step === 'success') {
      this.toastr.success('Imagem enviada com sucesso');
      // Tratar sucesso
    }
  }
}
